import React from 'react';
import { FadeIn } from '../FadeIn';
import { Check, MessageCircle, Lock } from 'lucide-react';
export function PricingAHA() {
  const includes = ['5 audio-uri ghidate cu voce, respirație și exerciții practice', 'Workbook PDF de 13 pagini cu journaling, fișe de lucru și reamintiri', 'Fișa personală „Momentul Cicatricii” pentru lucrul cu tiparele repetate', 'Fișa „Kitul meu de urgență emoțională”, planul tău personalizat pentru momentele grele', 'Acces în Grupul Cicatricilor pentru suport continuu', 'Acces pe viață la toate materialele'];
  return <section id="checkout" className="py-20 md:py-28 bg-ivory overflow-hidden relative" data-id="element-224">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-225">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gold/5 rounded-full blur-3xl" data-id="element-226"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-forest/5 rounded-full blur-3xl" data-id="element-227"></div>
        <div className="absolute top-20 left-20 w-32 h-32 border border-gold/20 rounded-full" data-id="element-228"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 border border-forest/10 rounded-full" data-id="element-229"></div>
      </div>

      <div className="max-w-[900px] mx-auto px-6 md:px-8 relative z-10" data-id="element-230">
        <div className="text-center max-w-[800px] mx-auto mb-12" data-id="element-231">
          <FadeIn data-id="element-232">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6" data-id="element-233">
              Ce primești în acest curs
            </h2>
          </FadeIn>
        </div>

        <FadeIn data-id="element-234">
          <div className="bg-white border border-gold/30 rounded-[32px] p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-235">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -z-10" data-id="element-236"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-forest/5 rounded-full blur-2xl -z-10" data-id="element-237"></div>

            {/* Includes list */}
            <div className="mb-12" data-id="element-238">
              <p className="text-sm font-display font-medium text-charcoal/60 uppercase tracking-wider mb-6" data-id="element-239">
                Ce e inclus:
              </p>
              <ul className="space-y-5" data-id="element-240">
                {includes.map((item, index) => <li key={index} className="flex items-start gap-4 pb-5 border-b border-gold/15 last:border-0 last:pb-0" data-id="element-241">
                    <Check className="w-6 h-6 text-gold-dark shrink-0 mt-0.5" data-id="element-242" />
                    <span className="text-[19px] text-charcoal/80 leading-relaxed" data-id="element-243">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* CTA */}
            <div className="text-center" data-id="element-244">
              <a href="https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201." target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-flex items-center justify-center px-10 py-5 rounded-full bg-forest text-ivory font-display text-xl font-medium hover:bg-forest-light transition-colors no-underline gap-3 group shadow-xl shadow-forest/20" data-id="element-245">
                <MessageCircle className="w-6 h-6" data-id="element-246" />
                Vreau detalii pe WhatsApp
              </a>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}